import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Input, Table, InputGroup, InputGroupAddon } from 'reactstrap'
import CreatableSelect from './CreatableSelect'
import RangeInput from './helpers/RangeInput'
import heatInputValue from './helpers/heatInputValue'
import FillerMaterialModal from '../Dictionary/FillerMaterialModal'

const baseWpsParameterRunOptions = [{ name: 'Lico', value: 'Lico' }, { name: '2-n', value: '2-n' }, { name: '1', value: '1' }]

class WpsParametersForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filler_material_modal_idx: null,
      welding_position_ids: [],
    }

    this.handleInputOnChange = this.handleInputOnChange.bind(this)
    this.handleAddDynamicInput = this.handleAddDynamicInput.bind(this)
    this.setFillerMaterial = this.setFillerMaterial.bind(this)
  }

  static propTypes = {
    welding_process_dict: PropTypes.array,
    welding_position_dict: PropTypes.array,
    type_of_current_polarity_dict: PropTypes.array,
    filler_material_dict: PropTypes.array,
    value: PropTypes.array.isRequired,
    validation_errors: PropTypes.array,
    valueChangeFunction: PropTypes.func.isRequired
  }

  handleAddDynamicInput() {
    let newValue = this.props.value
    newValue.push({
      run: '', current: [0, 0], voltage: [0, 0], wire_feed: [0, 0], travel_feed: [0, 0], filler_material_operate: '',
      filler_material_size: '', heat_input: [0, 0], filler_material: {}, type_of_current_polarity: {}, welding_process: {}, welding_position: {}, _destroy: null
    })
    this.props.valueChangeFunction(newValue)
  }

  handleRemoveDynamicInput(idx, presisted) {
    if (presisted) {
      let newValue = this.props.value
      newValue[idx]._destroy = 1
      this.props.valueChangeFunction(newValue)
    }
    else {
      this.props.valueChangeFunction(this.props.value.filter((s, sidx) => idx !== sidx))
    }
  }

  handleInputOnChange(e) {
    let inputName = e.target.name.split('__')[1]
    let idx = e.target.name.split('__')[0]
    let newValue = this.props.value
    newValue[idx][inputName] = e.target.value

    this.props.valueChangeFunction(newValue)
  }

  handleSelectValueChange(idx, inputName) {
    let self = this;

    function updateValue(selectedOptions) {
      let newValue = [...self.props.value];

      if (selectedOptions) {
        // Only collect the IDs
        const selectedValues = selectedOptions.map(option => option.id);
        newValue[idx][inputName] = selectedValues;
      } else {
        newValue[idx][inputName] = [];
      }

      self.props.valueChangeFunction(newValue);
    }
    return updateValue;
  }

  handleValueChangeFunction(idx, inputName) {
    let self = this

    function updateValue(val) {
      let newValue = self.props.value
      newValue[idx][inputName] = val

      self.props.valueChangeFunction(newValue)
    }

    return updateValue
  }

  setFillerMaterial(filler_material) {
    let setFillerMaterialFunc = this.handleValueChangeFunction(this.state.filler_material_modal_idx, 'filler_material')
    setFillerMaterialFunc(filler_material)
    this.setState({ filler_material_modal_idx: null })
  }


  renderRows() {
    return this.props.value.map((inputRecordData, idx) => {
      if (typeof (inputRecordData.run) === 'string' && inputRecordData.run !== '' && !baseWpsParameterRunOptions.map(o => o.value).includes(inputRecordData.run)) {
        baseWpsParameterRunOptions.push({ name: inputRecordData.run, value: inputRecordData.run })
      }
      let validationErrors = this.props.validation_errors[idx] || {}
      if (inputRecordData._destroy !== 1) {
        return ([
          <tr key={`first_row_${idx}`} style={{ backgroundColor: '#e9ecef' }}>
            <th style={{ borderTop: '1px solid #000000', borderLeft: '1px solid #000000' }}><b>Run:</b></th>
            <td>
              <CreatableSelect
                options={baseWpsParameterRunOptions}
                value={inputRecordData.run}
                valueKey={'value'}
                multi={false}
                creatable={true}
                valueChangeFunction={this.handleValueChangeFunction(idx, 'run')}
              />
            </td>
            <th><b>Welding process</b></th>
            <td colSpan={2}>
              <CreatableSelect options={this.props.welding_process_dict}
                valueKey="id"
                labelKey="label"
                value={(inputRecordData.welding_process || {}).id}
                multi={false}
                creatable={false}
                valueChangeFunction={this.handleValueChangeFunction(idx, 'welding_process')}
              />
            </td>
            <th><b>Welding positions</b></th>
            <td colSpan={2}>
              <CreatableSelect options={this.props.welding_position_dict}
                valueKey="id"
                labelKey="label"
                value={inputRecordData.welding_position_ids}
                multi={true}
                creatable={false}
                valueChangeFunction={this.handleSelectValueChange(idx, 'welding_position_ids')}
              />
            </td>
            <th><b>Type of current polarity</b></th>
            <td>
              <CreatableSelect options={this.props.type_of_current_polarity_dict}
                valueKey="id"
                labelKey="label"
                value={(inputRecordData.type_of_current_polarity || {}).id}
                multi={false}
                creatable={false}
                valueChangeFunction={this.handleValueChangeFunction(idx, 'type_of_current_polarity')}
              />
            </td>
            <th style={{ borderRight: '1px solid #000000' }}>Remove</th>
          </tr>,
          <tr key={`second_row_${idx}`} style={{ backgroundColor: '#e9ecef' }}>
            <th colSpan={2} style={{ borderLeft: '1px solid #000000' }}><b>Current [A]</b></th>
            <th colSpan={2}><b>Voltage [V]</b></th>
            <th colSpan={2}><b>Wire feed [m/min]</b></th>
            <th colSpan={2}><b>Travel speed [cm/min]</b></th>
            <th colSpan={2}><span title="(voltage * current * 6) / travel speed * 100">
              <b>Heat input [kJ/cm]</b><i className="fa fa-info-circle" /></span>
            </th>
            <td rowSpan={4} style={{ borderBottom: '1px solid #000000', borderRight: '1px solid #000000', textAlign: 'center', verticalAlign: 'middle', backgroundColor: '#ffffff' }}>
              <Button size="sm" color="danger" title="Remove" onClick={() => { this.handleRemoveDynamicInput(idx, inputRecordData.id) }}>
                <i className="fa fa-minus" />
              </Button>
            </td>
          </tr>,
          <tr key={`third_row_${idx}`} style={{ backgroundColor: '#e9ecef' }}>
            <th style={{ borderLeft: '1px solid #000000' }}>min</th>
            <th>max</th>
            <th>min</th>
            <th>max</th>
            <th>min</th>
            <th>max</th>
            <th>min</th>
            <th>max</th>
            <th>min</th>
            <th>max</th>
          </tr>,
          <tr key={`fifth_row_${idx}`} style={{ borderLeft: '1px solid #000000' }}>
            <RangeInput value={inputRecordData.current}
              label="Current [A]"
              uniqId={`current_${idx}`}
              invalid={validationErrors.current}
              valueChangeFunction={this.handleValueChangeFunction(idx, 'current')}
            />
            <RangeInput value={inputRecordData.voltage}
              label="Voltage [V]"
              uniqId={`voltage_${idx}`}
              invalid={validationErrors.voltage}
              valueChangeFunction={this.handleValueChangeFunction(idx, 'voltage')}
            />
            <RangeInput value={inputRecordData.wire_feed}
              label="Wire feed [m/min]"
              uniqId={`wire_feed_${idx}`}
              invalid={validationErrors.wire_feed}
              valueChangeFunction={this.handleValueChangeFunction(idx, 'wire_feed')}
            />
            <RangeInput value={inputRecordData.travel_speed}
              label="Travel speed [cm/min]"
              uniqId={`travel_speed_${idx}`}
              invalid={validationErrors.travel_speed}
              valueChangeFunction={this.handleValueChangeFunction(idx, 'travel_speed')}
            />
            <RangeInput
              value={heatInputValue(inputRecordData.voltage, inputRecordData.current, inputRecordData.travel_speed, inputRecordData.welding_process)}
              label="Heat input [kJ/cm]"
              uniqId={`heat_input_${idx}`}
              disabled={true}
              invalid={validationErrors.heat_input}
              valueChangeFunction={() => { }}
            />
          </tr>,
          <tr key={`sixth_row_${idx}`} style={{ backgroundColor: '#e9ecef' }}>
            <th style={{ borderBottom: '1px solid #000000', borderLeft: '1px solid #000000' }}><b>Filler material:</b></th>
            <td colSpan={3} style={{ borderBottom: '1px solid #000000' }}>
              <InputGroup>
                <div style={{ width: '92%' }}>
                  <CreatableSelect options={this.props.filler_material_dict}
                    valueKey="id"
                    value={inputRecordData.filler_material}
                    multi={false}
                    creatable={false}
                    valueChangeFunction={this.handleValueChangeFunction(idx, 'filler_material')} />
                </div>
                <InputGroupAddon addonType='append'>
                  <button
                    className="small-plus-btn"
                    title="Add new filler material"
                    onClick={(e) => {
                      e.preventDefault()
                      this.setState({ filler_material_modal_idx: idx })
                    }}><i className="fa fa-plus fa-xs" />
                  </button>
                </InputGroupAddon>
              </InputGroup>
            </td>
            <th style={{ borderBottom: '1px solid #000000' }}><b>Size:</b></th>
            <td colSpan={2} style={{ borderBottom: '1px solid #000000' }}>
              <Input name={`${idx}__filler_material_size`}
                value={inputRecordData.filler_material_size || ''}
                onChange={this.handleInputOnChange} />
            </td>
            <th style={{ borderBottom: '1px solid #000000' }}><b>Operate:</b></th>
            <td colSpan={2} style={{ borderBottom: '1px solid #000000' }}>
              <Input name={`${idx}__filler_material_operate`}
                value={inputRecordData.filler_material_operate || ''}
                onChange={this.handleInputOnChange} />
            </td>
          </tr>
        ])
      } else {
        return null
      }
    })
  }

  render() {
    return (
      <div>
        {typeof (this.state.filler_material_modal_idx) === 'number' &&
          <FillerMaterialModal
            onCancel={() => this.setState({ filler_material_modal_idx: null })}
            afterSubmit={this.setFillerMaterial}
          />}
        <Table className="table-center inputs-bottom-border-only" size="sm">
          <thead className="thead-light">
            <tr>
              <th colSpan={11}>
                <Button color="primary" size="sm" style={{ float: 'left' }} onClick={this.handleAddDynamicInput}>
                  <i className="fa fa-plus" /> Add
                </Button>
                <h3>WPS Parameters</h3>
              </th>
            </tr>
          </thead>
          <tbody>
            {this.renderRows()}
          </tbody>
        </Table>
      </div>
    )
  }
}

export default WpsParametersForm



// WEBPACK FOOTER //
// ./src/components/Wps/WpsParametersForm.js